'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './vehicle_parking.routes';

export class VehicleParkingComponent {
  /*@ngInject*/

  /*@ngInject*/
  constructor($state, $scope, $rootScope, fetch, lookup, userService, $timeout, baseConfigService, $http, $stateParams) {
    this.$scope = $scope;
    this.$state = $state;
    this.fetch = fetch;
    this.lookup = lookup;
    this.$stateParams = $stateParams;
    this.userService = userService;
    this.$timeout = $timeout;
    this.$http = $http;
    this.baseConfigService = baseConfigService;

    $scope.adminUnlocked = false; // track admin manual unlock
    $scope.attachmentData = $scope.attachmentData || {};
    $scope.submissions = [];
    $scope.savemode = null;
    $scope.baseUrl = baseConfigService.getBaseURL();

    $scope.vehicleParkingMinCheck = false;
    $scope.submitmode = null;
    $scope.initialLoad = true;

    $scope.parking = {};
    // $scope.type = 'Vehicle Parking';
    $scope.policy_name = 'Vehicle Parking Minimum';

    $scope.pendingChanges = false;
    $scope.showPanel = null;

    $scope.togglePanel = function (panelName) {
      $scope.showPanel = panelName;
    };

    $scope.setPending = function () {
      console.log('set pending ran')
      console.log($scope.initialLoad);
      if (!$scope.initialLoad) {
        $scope.savemode = 'parking';
        $scope.pendingChanges = true;
      }
    }

    $scope.isFormEditable = function () {
      if (!$scope.currentParkingPolicy) return true;

      var role = $scope.currentUser && $scope.currentUser.role;

      // Find matching submission status for current policy
      var submission = null;
      if ($scope.parkingStatus) {
        for (var i = 0; i < $scope.parkingStatus.length; i++) {
          if ($scope.parkingStatus[i].submission_policy_name === $scope.policy_name) {
            submission = $scope.parkingStatus[i];
            break;
          }
        }
      }

      // Not yet submitted — allow editing
      if (!submission || !submission.submitted) return true;


      // Admins can edit if they've manually unlocked
      if (role === 'Administrator') {
        return $scope.adminUnlocked;
      }

      // Admin set it to "Needs Work" — allow editing without withdraw
      if (submission.status === 'Needs Work') return true;

      // Otherwise submitted and locked — user must withdraw to edit
      return false;
    };

    $scope.$watch(
      function () {
        return $scope.currentParkingPolicy
      },
      function () {
        $scope.adminUnlocked = false;
        $scope.formReadOnly = !$scope.isFormEditable();
        $scope.withdrawnNotice = false;
        $scope.needsWorkNotice = false;
        if ($scope.parkingStatus && $scope.policy_name) {
          var sub = _.find($scope.parkingStatus, { submission_policy_name: $scope.policy_name });
          if (sub && sub.submitted && sub.status === 'Needs Work') { $scope.needsWorkNotice = true; }
        }
      }
    );

    $scope.$watch('parkingStatus', function () {
      if (!$scope.currentParkingPolicy) return;
      $scope.formReadOnly = !$scope.isFormEditable();
    }, true);

    $scope.toggleAdminUnlock = function () {
      $scope.adminUnlocked = !$scope.adminUnlocked;
      $scope.formReadOnly = !$scope.isFormEditable();
    };

    $scope.withdrawSubmission = function () {
      var confirmWithdraw = window.confirm(
        'Are you sure you want to withdraw this submission? You will need to complete the Review and Submit process again after making changes.'
      );
      if (!confirmWithdraw) return;

      // Find matching submission using $scope.policy_name (current active tab policy)
      var submission = null;
      if ($scope.parkingStatus) {
        for (var i = 0; i < $scope.parkingStatus.length; i++) {
          if ($scope.parkingStatus[i].submission_policy_name === $scope.policy_name) {
            submission = $scope.parkingStatus[i];
            break;
          }
        }
      }

      if (!submission || !submission.submission_id) {
        console.error('No matching submission found to withdraw');
        return;
      }

      var payload = {
        submission_id: submission.submission_id,
        submitted: false,
        status: null
      };

      fetch.updateItem('api/data/submissions/update-status', payload)
        .then(function () {
          submission.submitted = false;
          submission.status = null;

          if (
            $scope.checkParking1 &&
            $scope.checkParking1.submission_id === submission.submission_id
          ) {
            $scope.checkParking1 = null;
            $scope.vehicleParkingMinCheck = false;
            $scope.parking.vehicleParkingMinCheck = false;
            if ($scope.vehicleParkingMinimum) {
              $scope.vehicleParkingMinimum.forEach(function (el) {
                el.submitted = false;
              });
            }
          }

          if (
            $scope.checkParking2 &&
            $scope.checkParking2.submission_id === submission.submission_id
          ) {
            $scope.checkParking2 = null;
            $scope.vehicleParkingMaxCheck = false;
            $scope.parking.vehicleParkingMaxCheck = false;
            if ($scope.vehicleParkingMaximum) {
              $scope.vehicleParkingMaximum.forEach(function (el) {
                el.submitted = false;
              });
            }
          }

          $scope.formReadOnly = false;

          // Clear form fields — preserve only identity fields
          var formId = $scope.currentParkingPolicy ? $scope.currentParkingPolicy.parking_form_id : null;
          $scope.currentParkingPolicy = { parking_form_id: formId };

          // Show withdrawn notification
          $scope.withdrawnNotice = true;
          $scope.needsWorkNotice = false;
          $scope.success = false;
        })
        .catch(function (err) {
          console.error('Withdraw failed:', err);
          alert('There was an error withdrawing the submission. Please try again.');
        });
    };

    $scope.onVehicleParkingMinCheckboxChange = function (type) {
      if (type === 'confirmationCompliance' && $scope.currentParkingPolicy.parking_confirmation_compliance_checked) {
        $scope.currentParkingPolicy.parking_resolution_compliance_checked = false;
        $scope.currentParkingPolicy.remove_vehicle_park_mins_checked = false;
      }
      if (type === 'resolutionCompliance' && $scope.currentParkingPolicy.parking_resolution_compliance_checked) {
        $scope.currentParkingPolicy.parking_confirmation_compliance_checked = false;
        $scope.currentParkingPolicy.remove_vehicle_park_mins_checked = false;
      }
      if (type === 'removeVehicleParkingMins' && $scope.currentParkingPolicy.remove_vehicle_park_mins_checked) {
        $scope.currentParkingPolicy.parking_confirmation_compliance_checked = false;
        $scope.currentParkingPolicy.parking_resolution_compliance_checked = false;
      }
    };

    $scope.onVehicleParkingMaxCheckboxChange = function (type) {
      if (type === 'overlayZone' && $scope.currentParkingPolicy.vehicle_park_max_overlay_zone_checked) {
        $scope.currentParkingPolicy.vehicle_park_max_limit_park_method_checked = false;

      }
      if (type === 'limitParkMethod' && $scope.currentParkingPolicy.vehicle_park_max_limit_park_method_checked) {
        $scope.currentParkingPolicy.vehicle_park_max_overlay_zone_checked = false;
      }
    };



    $scope.addToSubmissions = function (submission) {
      const index = $scope.submissions.indexOf(submission);
      if (index > -1) { // only splice array when item is found
        $scope.submissions.splice(index, 1); // 2nd parameter means remove one item only
      } else {
        $scope.submissions.push(submission);

      }
      console.log($scope.submissions)
      if ($scope.submissions.length > 0) {
        $scope.submitmode = 'parking';
      } else {
        $scope.submitmode = null;

      }
    }

    $scope.getSubmissionStatus = function () {
      fetch.getItem(`api/data/submissions/${$scope.currentJurisdiction}/${$scope.currentSelectedStationId}`, `Parking`)
        .then(response => {
          $scope.parkingStatus = response.data;

          $scope.checkParking1 = (_.filter(response.data, {
            submission_policy_name: 'Vehicle Parking Minimum',
            submitted: true
          }))[0];

          $scope.checkParking2 = (_.filter(response.data, {
            submission_policy_name: 'Vehicle Parking Maximum',
            submitted: true
          }))[0];

          // Reset check flags if not submitted so checkboxes uncheck after withdraw
          $scope.vehicleParkingMinCheck = !!($scope.checkParking1 && $scope.checkParking1.submitted);
          $scope.vehicleParkingMaxCheck = !!($scope.checkParking2 && $scope.checkParking2.submitted);
        })
        .catch(err => {
          console.log(err);
        });
    };

    $scope.updateSubmissionStatus = function (row, newStatus) {

      if (!row || !row.submission_id) {
        console.error('submission_id is missing:', row);
        return;
      }

      const originalStatus = row.status;

      // Update the UI immediately
      row.status = newStatus;

      const updateData = {
        submission_id: row.submission_id,
        status: newStatus
      };

      console.log('Updating submission:', {
        id: row.submission_id,
        status: newStatus
      });

      fetch.updateItem('api/data/submissions/update-status', updateData)
        .then(response => {
          $timeout(() => {
            $scope.successMessage = 'Status updated successfully';
          });
        })
        .catch(err => {
          console.error('Error updating status:', err);
          $timeout(() => {
            // Revert the status if update failed
            row.status = originalStatus;
            $scope.error = 'Failed to update status';
          });
        });
    };

    $scope.getStationbyID = function (station) {

      if (station) {
        $scope.currentSelectedStationId = station;
        lookup.setCurrentStation(station);
      }
      $scope.getSubmissionStatus();
      fetch.getItem(`api/data/submissions/${$scope.currentJurisdiction}/${$scope.currentSelectedStationId}`, 'Parking')
        .then(response => {

          $scope.currentStation = response.data[0];

          $scope.complementaryParking = _.filter(response.data, { submission_policy_name: 'Complementary Parking Management Policy' });
          if ($scope.complementaryParking.length > 0) {
            $scope.complementaryParking.forEach(element => {
              if (element.submitted == true) {
                $scope.complementaryParkCheck = true;
              }
            });
          }
          $scope.unbundledParking = _.filter(response.data, { submission_policy_name: 'Unbundled Parking' });
          if ($scope.unbundledParking.length > 0) {
            $scope.unbundledParking.forEach(element => {
              if (element.submitted == true) {
                $scope.unbundledParkCheck = true;
              }
            });
          }
          $scope.sharedParking = _.filter(response.data, { submission_policy_name: 'Shared Parking' });
          if ($scope.sharedParking.length > 0) {
            $scope.sharedParking.forEach(element => {
              if (element.submitted == true) {
                $scope.sharedParkCheck = true;
              }
            });
          }
          $scope.vehicleParkingMaximum = _.filter(response.data, { submission_policy_name: 'Vehicle Parking Maximum' });
          if ($scope.vehicleParkingMaximum.length > 0) {
            $scope.vehicleParkingMaximum.forEach(element => {
              if (element.submitted == true) {
                $scope.vehicleParkingMaxCheck = true;
              }
            });
          }
          $scope.vehicleParkingMinimum = _.filter(response.data, { submission_policy_name: 'Vehicle Parking Minimum' });
          if ($scope.vehicleParkingMinimum.length > 0) {
            $scope.vehicleParkingMinimum.forEach(element => {
              if (element.submitted == true) {
                $scope.vehicleParkingMinCheck = true;
              }
            });
          }
          $scope.bicycleParkingMinimum = _.filter(response.data, { submission_policy_name: 'Bicycle Parking Minimum' });
          if ($scope.bicycleParkingMinimum.length > 0) {
            $scope.bicycleParkingMinimum.forEach(element => {
              if (element.submitted == true) {
                $scope.bicycleParkingMinCheck = true;
              }
            });
          }
          $scope.getStationTier($scope.currentSelectedStationId);

          // Check if a specific policy was requested via policyName parameter
          const requestedPolicyName = $stateParams.policyName;
          // console.log('Vehicle Parking: Requested policy name from URL:', requestedPolicyName);
          // console.log('Vehicle Parking: Current policy_name before:', $scope.policy_name);
          if (requestedPolicyName) {
            $scope.policy_name = requestedPolicyName;
            console.log('Vehicle Parking: Setting policy_name to:', $scope.policy_name);

            // Activate the correct tab based on the policy name
            $timeout(() => {
              let targetTab;
              if (requestedPolicyName === 'Vehicle Parking Minimum') {
                targetTab = '#section-1';
              } else if (requestedPolicyName === 'Vehicle Parking Maximum') {
                targetTab = '#section-2';
              }

              if (targetTab) {
                // Remove active class from all tabs
                document.querySelectorAll('[data-bs-toggle="tab"]').forEach(tab => {
                  tab.classList.remove('active');
                });
                document.querySelectorAll('.tab-pane').forEach(pane => {
                  pane.classList.remove('show', 'active');
                });

                // Activate the target tab
                const tabTrigger = document.querySelector(`[data-bs-target="${targetTab}"]`);
                if (tabTrigger) {
                  tabTrigger.classList.add('active');
                  const tabPane = document.querySelector(targetTab);
                  if (tabPane) {
                    tabPane.classList.add('show', 'active');
                  }
                }
                // console.log('Activated tab:', targetTab);
              }
            }, 100);
          } else {
            // console.log('Vehicle Parking: No policyName parameter, using default:', $scope.policy_name);
          }

          return $scope.getCurrentParkingPolicy($scope.policy_name);

        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        })
    }

    $scope.getStationTier = function (station) {
      if (station) {
        $scope.loadingData = true;
      }
      fetch.getItem(`api/data/parking/station-tiers/${$scope.currentJurisdiction}`, $scope.currentSelectedStationId)
        .then(response => {
          $scope.currentStation = response.data[0];
          $scope.loadingData = false;
        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        })
    };

    $scope.getCurrentParkingPolicy = function (policy_name) {
      if (policy_name) {
        $scope.policy_name = policy_name;
      }
      console.log('policy_name:', policy_name);

      fetch.getAllItems(`api/data/getParkingForm/${$scope.currentJurisdiction}/${$scope.currentSelectedStationId}/${encodeURIComponent($scope.policy_name)}`)
        .then(response => {


          $scope.currentParkingPolicy = response.data[0];

          console.log('parking_form_id:', $scope.currentParkingPolicy.parking_form_id);
          if (policy_name === 'Vehicle Parking Maximum') {
            $scope.currentParkingPolicy.vehicle_park_max_overlay_zone_checked =
              !!($scope.currentParkingPolicy.vehicle_park_max_overlay_zone_municipal ||
                $scope.currentParkingPolicy.vehicle_park_max_overlay_zone_equivalency);
            $scope.currentParkingPolicy.vehicle_park_max_limit_park_method_checked =
              !!($scope.currentParkingPolicy.vehicle_park_max_park_management ||
                $scope.currentParkingPolicy.vehicle_park_max_limit_park_equivalency ||
                $scope.currentParkingPolicy.vehicle_park_max_off_street_park_calculation);
          }
          if (policy_name === 'Vehicle Parking Minimum') {
            // FIXED: set on currentParkingPolicy not $scope directly
            $scope.currentParkingPolicy.parking_confirmation_compliance_checked =
              !!$scope.currentParkingPolicy.parking_confirmation_compliance;
            $scope.currentParkingPolicy.parking_resolution_compliance_checked =
              !!$scope.currentParkingPolicy.parking_resolution_compliance;
            $scope.currentParkingPolicy.remove_vehicle_park_mins_checked =
              !!$scope.currentParkingPolicy.remove_vehicle_park_mins;
          }
          $scope.initialLoad = false;
          console.log($scope.initialLoad);
        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        })

    }
    $scope.updateCurrentParkingPolicy = function () {

      $scope.formSubmitted = true;
      if (parkingForm.$invalid) {
        $scope.saving = false;
        return;
      }

      // Ensure cleared fields send `null` instead of empty strings or undefined values
      Object.keys($scope.currentParkingPolicy).forEach(key => {
        if ($scope.currentParkingPolicy[key] === "" || $scope.currentParkingPolicy[key] === undefined) {
          $scope.currentParkingPolicy[key] = null;
        }
      });

      // Add parking_form_id to the payload
      $scope.currentParkingPolicy.parking_form_id = $scope.currentParkingPolicy.parking_form_id;

      console.log("Payload being sent:", $scope.currentParkingPolicy);
      fetch.updateItem(`api/data/parking/forms/update`, $scope.currentParkingPolicy)
        .then(response => {

          $scope.saved = true;
          $scope.saving = false;
          $scope.pendingChanges = false;
          setTimeout(() => {
            // $scope.submitmode = null;
            $scope.saved = false;
            $scope.savemode = null;
            $scope.$apply();
          }, 4000);
        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        })
    }

    $scope.submitParking = function () {
      console.log($scope.parking.vehicleParkingMaxCheck);
      $scope.formSubmitted = true;
      $scope.saving = true;
      var upsertData = []; // Initialize upsertData array

      $scope.upsertData = []; // Reset or initialize upsert data array

      console.log("submissing", $scope.parking.vehicleParkingMaxCheck, $scope.vehicleParkingMaximum.length)
      if ($scope.parking.complementaryParkCheck && $scope.complementaryParking.length > 0) {
        $scope.complementaryParking.forEach(element => {
          if (!element.submitted) {
            element.submitted = true;
            upsertData.push({
              submission_id: element.submission_id,
              complementary_parking_management: true,
              submitted: true,
            })
          }
        });
      }

      if ($scope.parking.unbundledParkCheck && $scope.unbundledParking.length > 0) {
        $scope.unbundledParking.forEach(element => {
          if (!element.submitted) {
            element.submitted = true;
            upsertData.push({
              submission_id: element.submission_id,
              unbundled_parking: true,
              submitted: true,
            })
          }
        });
      }

      if ($scope.parking.sharedParkCheck && $scope.sharedParking.length > 0) {
        $scope.sharedParking.forEach(element => {
          if (!element.submitted) {
            element.submitted = true;
            upsertData.push({
              submission_id: element.submission_id,
              shared_parking: true,
              submitted: true,
            })
          }
        });
      }

      if ($scope.parking.vehicleParkingMaxCheck && $scope.vehicleParkingMaximum.length > 0) {
        $scope.vehicleParkingMaximum.forEach(element => {
          if (!element.submitted) {
            element.submitted = true;
            upsertData.push({
              submission_id: element.submission_id,
              vehicle_parking_maximum: true,
              submitted: true,
            })
          }
        });
      }

      if ($scope.parking.vehicleParkingMinCheck && $scope.vehicleParkingMinimum.length > 0) {
        $scope.vehicleParkingMinimum.forEach(element => {
          if (!element.submitted) {
            element.submitted = true;
            upsertData.push({
              submission_id: element.submission_id,
              vehicle_parking_minimum: true,
              submitted: true,
            })
          }
        });
      }

      if ($scope.parking.bicycleParkingMinCheck && $scope.bicycleParkingMinimum.length > 0) {
        $scope.bicycleParkingMinimum.forEach(element => {
          if (!element.submitted) {
            element.submitted = true;
            upsertData.push({
              submission_id: element.submission_id,
              bicycle_parking_minimum: true,
              submitted: true,
            })
          }
        });
      }

      // Add submission data to upsertData
      // $scope.upsertData.push($scope.currentParkingPolicy);



      // $scope.upsertData = _.union($scope.stationCompleteStreets, $scope.stationProjectPrioritization, $scope.stationGapAnalysis, $scope.stationMobilityHubPlanning);

      fetch.updateItem('api/data/submissions/update', upsertData)
        .then(response => {

          $scope.saving = false;
          $scope.submissions = [];
          $scope.saved = true;
          $scope.pendingChanges = false;
          $scope.getSubmissionStatus();
          setTimeout(() => {
            $scope.submitmode = null;
            $scope.saved = false;
            $scope.$apply();
          }, 2000);
        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        })
    }

    /**
* Update station area dropdown based on jurisdiction selected
* @param {*} jurisdiction 
*/
    $scope.getStationAreaList = function (jurisdiction) {
      // Check for sta_recid parameter from $stateParams
      const staRecId = $stateParams.sta_recid;

      lookup.setJurisdiction(jurisdiction);
      fetch.getAllItems(`api/data/stationareas/${jurisdiction}`)
        .then(response => {

          $scope.stationAreas = response.data;

          // Set currentSelectedStationId based on sta_recid
          if (staRecId) {
            $scope.currentSelectedStationId = staRecId;
          } else if (lookup.getCurrentStation()) {
            $scope.currentSelectedStationId = lookup.getCurrentStation();
          }

          // Call getStationbyID() after setting the currentSelectedStationId
          if ($scope.currentSelectedStationId) {
            $scope.getStationbyID($scope.currentSelectedStationId);
          }
        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        })
    }

    // File upload functions 

    $scope.initializeField = function (fieldId) {
      if (!$scope.attachmentData[fieldId]) {
        $scope.attachmentData[fieldId] = {
          fileName: null,
          file: null,
          isFileSelected: false
        };
      }
    };

    // Function to open the file dialog
    $scope.openFileDialog = function (fieldId) {
      $timeout(function () {
        document.getElementById('fileInput' + fieldId).click();
      }, 0);
    };

    // Function to handle file changes
    $scope.fileChanged = function (fieldId, element) {
      $scope.initializeField(fieldId);  // Ensure field is initialized

      var file = element.files[0];
      if (file) {
        // Check if the file type is PDF, Word document, or Excel file
        if (
          file.type !== 'application/pdf' &&
          file.type !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && // For .docx
          file.type !== 'application/msword' && // For .doc
          file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && // For .xlsx
          file.type !== 'application/vnd.ms-excel' // For .xls
        ) {
          alert('Please select a PDF, Word document, or Excel file.');
          element.value = ''; // Reset input to clear the wrong file type
          return;
        }

        $scope.attachmentData[fieldId].fileName = file.name;
        $scope.attachmentData[fieldId].file = file;
        $scope.attachmentData[fieldId].isFileSelected = true;

        $scope.$apply();
      }
    };

    $scope.clearFile = function (ngmodel) {
      console.log(ngmodel);
      var fileInput = document.getElementById(`${ngmodel}`);
      console.log(fileInput);
      if (fileInput) {
        fileInput.value = ''; // clears the file input
        // Clear any associated model/preview values
        $scope[ngmodel] = '';
        $scope[`${ngmodel}_preview`] = '';
        $scope[`fileUploading_${ngmodel}`] = false;

        // If there's a form control, reset its validation state
        if ($scope.form && $scope.form[ngmodel]) {
          $scope.form[ngmodel].$setPristine();
          $scope.form[ngmodel].$setUntouched();
        }
      }
    };

    $scope.uploadFile = function (ngmodelfile) {
      var ngmodel = ngmodelfile.substring(0, ngmodelfile.length - 10);
      console.log(ngmodel);
      $scope[`fileUploading_${ngmodelfile}`] = true;
      var file = document.getElementById(`${ngmodelfile}`).files[0];

      if (!file) {
        console.error('No file selected');
        return;
      }

      var fileUpload = {
        fileName: file.name,
        fileType: file.type
      };

      // Using POST to get the signed URL and public URL
      fetch.updateItem('api/data/get-signed-url', fileUpload)
        .then(response => {
          console.log('Signed URL:', response.data.signedUrl);
          console.log('Public URL:', response.data.publicUrl);

          // Use the signed URL to upload the file
          return $http({
            method: 'PUT',
            url: response.data.signedUrl,
            data: file,
            headers: {
              'Content-Type': file.type,
              // 'x-amz-acl': 'public-read' // Ensure the file is publicly readable
            }
          })
            .then(() => {
              // After successful upload, store the public URL in the scope
              $scope.currentParkingPolicy[ngmodel] = response.data.publicUrl;
              return response.data.publicUrl; // Return the public URL for further use
            });
        })
        .then(publicUrl => {
          console.log('Upload successful');
          console.log('Public URL:', publicUrl);

          // Update UI state
          $scope[`fileUploading_${ngmodelfile}`] = false;
          $scope[`${ngmodelfile}`] = '';
          $scope.clearFile(ngmodelfile);
          $scope.uploadSuccess = true;
        })
        .catch(error => {
          console.error('Error:', error);
          alert('Upload failed');
        });
    };

    $scope.checkSubstring = function (input) {
      return input && input.length >= 4 && input.substring(0, 4) === 'http';
    };

    $scope.removeFile = function (ngmodel) {
      console.log(ngmodel);
      $scope.currentParkingPolicy[ngmodel] = '';
      $scope.setPending();
      $scope.savemode = 'parking';
      $scope.pendingChanges = true;
    };


    // End file upload functions 
  }

  $onInit() {

    this.userService.getCurrentUser()
      .then(response => {

        this.$scope.currentUser = response.data;
        this.userService.setCurrentUser(response.data);
        this.$scope.currentParkingPolicy = {};
        return this.getJurisdictionList();


      })
      .catch(err => {
        console.log(err);
        if (err.status === 403) {
          this.$state.go('login');
        }
      })
  }

  getJurisdictionList() {
    this.fetch.getAllItems('api/data/jurisdictions/jurisdiction-list')
      .then(response => {
        this.$scope.loading = false;
        this.$scope.jurisdictions = response.data;

        // Check if user role is Administrator
        if (this.$scope.currentUser.role === 'Administrator') {
          console.log("admin");
          // Check for the jurisdiction parameter in the URL
          const jurisdictionParam = this.$stateParams.jurisdiction;
          console.log(this.$stateParams);
          if (jurisdictionParam) {
            this.$scope.currentJurisdiction = jurisdictionParam;
          } else if (this.lookup.getJurisdiction()) {
            this.$scope.currentJurisdiction = this.lookup.getJurisdiction();
          } else {
            // If no parameter, default to the first jurisdiction
            this.$scope.currentJurisdiction = this.$scope.jurisdictions[0].jurisdiction;
          }
        } else {
          if (this.lookup.getJurisdiction()) {
            this.$scope.currentJurisdiction = this.lookup.getJurisdiction();
          } else {
            // If no parameter, default to the first jurisdiction
            this.$scope.currentJurisdiction = this.$scope.jurisdictions[0].jurisdiction;
          }
        }

        console.log(this.$scope.currentJurisdiction);
        this.lookup.setJurisdiction(this.$scope.currentJurisdiction);
        this.$scope.getStationAreaList(this.$scope.currentJurisdiction);
      })
      .catch(err => {
        console.log(err);
      });
  }
}

export default angular.module('appApp.vehicle_parking', [uiRouter])
  .config(routes)
  .component('vehicleParking', {
    template: require('./vehicle_parking.html'),
    controller: VehicleParkingComponent,
    controllerAs: 'vehicleParkingCtrl'
  })
  .name;




// WEBPACK FOOTER //
// ./client/app/account/parking/vehicle_parking/vehicle_parking.component.js